import { render } from "./HBorderPanel.vue?vue&type=template&id=df6fffb4&scoped=true&ts=true"
import script from "./HBorderPanel.vue?vue&type=script&lang=ts"
export * from "./HBorderPanel.vue?vue&type=script&lang=ts"

import "./HBorderPanel.vue?vue&type=style&index=0&id=df6fffb4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6fffb4"]])

export default __exports__